import {
  WidgetDisplayConfig,
  WidgetEntrySource,
  WidgetEntryWithData,
  WidgetType,
  WidgetWithData,
} from '@models/widget/widget.model';
import { WIDGET_NUMBER_DEFAULT_COLOR, WIDGET_SERIES_DEFAULT_COLORS } from '@models/widget/widget.constants';

export interface WidgetPreviewEntryMeta {
  color?: string;
  label?: string;
  unit?: string;
  dataSourceType?: WidgetEntrySource;
}

const PREVIEW_TIMESTAMPS: string[] = [
  '2026-01-01T08:00:00',
  '2026-01-01T09:00:00',
  '2026-01-01T10:00:00',
  '2026-01-01T11:00:00',
  '2026-01-01T12:00:00',
  '2026-01-01T13:00:00',
  '2026-01-01T14:00:00',
];

const PREVIEW_VALUES: number[][] = [
  [28, 31, 27, 33, 30, 35, 29],
  [18, 21, 19, 22, 20, 24, 21],
  [55, 58, 53, 60, 57, 62, 56],
];

const PREVIEW_AREA_PROPERTY_DATE = '2026-06-18T00:00:00';

const DEVICE_LIST_DEFAULT_ENTRIES: WidgetPreviewEntryMeta[] = [
  { color: '#2563eb', label: 'Temperatura', unit: 'C' },
  { color: '#16a34a', label: 'Humedad',     unit: '%' },
  { color: '#f59e0b', label: 'Radiacion',   unit: 'W/m2' },
];

export function buildPreviewEntries(entries: WidgetPreviewEntryMeta[], type: WidgetType = 'LINE'): WidgetEntryWithData[] {
  const defaultColor = type === 'NUMBER' ? WIDGET_NUMBER_DEFAULT_COLOR : WIDGET_SERIES_DEFAULT_COLORS[0];
  const safeEntries = entries.length ? entries : [{ color: defaultColor, label: 'Entrada 1' }];

  return safeEntries.map((entry, i) => {
    const source = entry.dataSourceType ?? 'DEVICE';
    const isAreaProperty = source === 'AREA_PROPERTY';
    return {
      id: `preview-${i}`,
      dataSourceType: source,
      color: entry.color ?? (type === 'NUMBER' ? WIDGET_NUMBER_DEFAULT_COLOR : WIDGET_SERIES_DEFAULT_COLORS[i % WIDGET_SERIES_DEFAULT_COLORS.length]),
      label: entry.label ?? `Entrada ${i + 1}`,
      unit: entry.unit ?? '',
      order: i,
      data: isAreaProperty
        ? [{ date: PREVIEW_AREA_PROPERTY_DATE, value: type === 'NUMBER' ? '18 jun 2026' : PREVIEW_VALUES[i % PREVIEW_VALUES.length][0] }]
        : PREVIEW_TIMESTAMPS.map((date, j) => ({
            date,
            value: PREVIEW_VALUES[i % PREVIEW_VALUES.length][j],
          })),
    };
  });
}

export function buildPreviewWidget(
  type: WidgetType,
  title: string,
  config: WidgetDisplayConfig,
  entries: WidgetPreviewEntryMeta[],
): WidgetWithData {
  let effectiveEntries = entries;
  if (type === 'DEVICE_LIST' && entries.length < 3) {
    effectiveEntries = [
      ...entries,
      ...DEVICE_LIST_DEFAULT_ENTRIES.slice(entries.length),
    ];
  }

  return {
    id:             'preview-widget',
    dashboardId:    'preview',
    widgetType: type,
    title:          title || 'Titulo del widget',
    widgetOwner:    'ADMIN',
    config,
    entries:        buildPreviewEntries(effectiveEntries, type),
    gridCol:        1,
    gridRow:        1,
    gridColSpan:    1,
    gridRowSpan:    1,
    displayOrder:   0,
    isLocked:       false,
    adminWidgetId:  null,
    createdAt:      '',
    updatedAt:      '',
  };
}
